/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Avatar, Button, Form, Grid, Input, Pagination, Spin, Space } from 'antd';
import Image from 'next/image';
import stylesModule from './popularRecruiterView.module.less';
import {
  FacebookFilled,
  GlobalOutlined,
  InstagramFilled,
  LinkedinFilled,
  SearchOutlined,
  TwitterSquareFilled,
  UserOutlined,
  YoutubeFilled,
} from '@ant-design/icons';
// import Link from 'next/link';
import { useConnection } from '../../connection/Application';
import SearchIcon from '../../public/search.svg';
import { DataTablePagination } from '../DataTable/DataTable';
import { useRouter } from 'next/router';
import { CandidateLayout, SEO_COMMON } from '../../layout/candidate/CandidateLayout';
import { useCachedData } from '../../connection/CacheContext';
import Link from 'antd/lib/typography/Link';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';

const styles: any = stylesModule;

export const PopularEmplyersSection: FC<{ value?: any[]; totalRecords?: number }> = ({
  value,
  totalRecords,
}) => {
  const [Data, setData] = useState<any[]>(value ?? []);
  const [advertData, setAdvertdata] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const connection = useConnection();
  const router = useRouter();
  const { enumValue } = useCachedData();
  const [searchName, setSearchName] = useState<string>('');
  const [pagination, setPagination] = useState<DataTablePagination>({
    page: 1,
    size: 10,
  });

  const [currentpage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(totalRecords ?? -1);
  const [form] = Form.useForm();

  const search = useCallback(
    (pagination: DataTablePagination, sort, sortdir, searchValue) => {
      const data: any = {
        activity: 'MustNotInactive',
      };
      setLoading(true);
      scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      connection
        .get(`home/recruiter-ordered`, {
          sortdir,
          // sort,
          from: (pagination.page - 1) * pagination.size,
          size: pagination.size,
          search: searchValue,
          ...data,
        })
        .then((v) => {
          console.log({ v });
          // setAdvertdata(v.activeAdverts);
          // setData(v.recruiters.sort((a: any, b: any) => a.name.localeCompare(b.name)));
          setData(v.recruiters);
          setTotal(v.total);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    },
    [connection],
  );

  // useEffect(() => {
  //   setPagination({ page: +(router.query?.page ?? 1), size: 8 });
  //   search({ page: currentpage, size: 8 }, 'time', 'asc', searchName);
  //   // eslint-disable-next-line
  // }, [router.query.status, currentpage, searchName]);
  // const handlePagination = useCallback(
  //   (text?: string) => {
  //     search({ page: 1, size: 8 }, 'time', 'asc', text);
  //   },
  //   [search],
  // );
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('page') == null) {
      setCurrentPage(1);
      search({ page: currentpage, size: 10 }, 'time', 'asc', searchName);
    } else {
      setCurrentPage(parseInt(params.get('page') || ''));
    }
    const page = parseInt(params.get('page') || '');
    search({ page, size: 10 }, 'time', 'asc', searchName);

    // eslint-disable-next-line
  }, []);

  const bp = Grid.useBreakpoint();
  const handlerSearch = useCallback(
    (text?: string) => {
      search({ page: 1, size: 10 }, 'time', 'asc', text);
    },
    [search],
  );
  return (
    <CandidateLayout
      title={
        <NextSeo
          description="Connect with top talent today through Sri Lanka's leading recruitment portal, Careers360. Apply today and unlock a world of career opportunities."
          additionalMetaTags={[
            {
              name: 'keywords',
              content: 'Recruitment portal in Sri Lanka',
            },
          ]}
          title={'Recruitment Portal in Sri Lanka | Partner with Excellence, Careers360'}
          canonical="https://www.careers360.lk/recruiters"
          {...SEO_COMMON}
        />
      }>
      <div style={bp.xs ? { padding: '0px' } : { width: '100%' }} className={styles.container}>
        <div className={styles.searchrow}>
          <div className={styles.searchform}>
            <Form
              form={form}
              // name="control-hooks"
              onFinish={(v) => {
                setSearchName(v.text);
                handlerSearch(v.text);
                setCurrentPage(1);
              }}>
              <Form.Item name={'text'}>
                <Input
                  allowClear={true}
                  bordered={true}
                  // prefix={<SearchOutlined style={{ color: '#707070' }} />}
                  placeholder={'Search Company'}
                  style={
                    bp.xs
                      ? {
                          borderRadius: '10px',
                          color: 'black',
                          height: 70,
                          position: 'absolute',
                        }
                      : {
                          borderRadius: '10px 0px 0px 10px',
                          color: 'black',
                        }
                  }
                />
              </Form.Item>
            </Form>
          </div>
          {!bp.xs && (
            <Button
              style={
                bp.xs
                  ? { height: 70, borderRadius: '0px 10px 10px 0px', padding: '0px !important' }
                  : { borderRadius: '0px 10px 10px 0px', width: '152px' }
              }
              // loading={loading}
              htmlType="submit"
              onClick={form.submit}
              type="primary">
              {/* <div style={{ gap: '5px' }}> */}
              <div className={styles.searchbtncontainer}>
                {' '}
                <Image
                  // className={styles.spaceitem}
                  src={SearchIcon}
                  alt={'Search'}
                  width={14}
                  height={20}
                />
                {bp.xs ? '' : 'Search Now'}
              </div>
              {/* <Space>
                <div className={styles.searchbtn}>
                  <Image
                    className={styles.spaceitem}
                    src={SearchIcon}
                    alt={'Search'}
                    width={14}
                    height={20}
                  />
                </div>
                
              </Space> */}
              {/* </div> */}
            </Button>
          )}
        </div>

        {loading && <div className={styles.spin}>{loading && <Spin />}</div>}

        {!loading && (
          <div className={styles.cardcontainer}>
            {total === 0 ? <h3>Not Found</h3> : ''}
            {Data.map((item) => {
              return (
                <div className={styles.card} key={item.recruiterId}>
                  {bp.xs && (
                    <div className={styles.columnsIcon}>
                      <div className={styles.socialicons}>
                        {item?.website ? (
                          <a href={item?.website}>
                            <GlobalOutlined style={{ color: '#6C6C6C', fontSize: '20px' }} /> &nbsp;
                          </a>
                        ) : null}
                        {item?.linkedin ? (
                          <a href={item.linkedin}>
                            <LinkedinFilled style={{ color: '#6C6C6C', fontSize: '20px' }} /> &nbsp;
                          </a>
                        ) : null}
                        {item?.facebook ? (
                          <a href={item.facebook}>
                            <FacebookFilled
                              shape="circle"
                              style={{ color: '#6C6C6C', fontSize: '20px' }}
                            />{' '}
                            &nbsp;
                          </a>
                        ) : null}
                        {item?.instagram ? (
                          <a href={item.instagram}>
                            <InstagramFilled
                              shape="circle"
                              style={{ color: '#6C6C6C', fontSize: '20px' }}
                            />{' '}
                            &nbsp;
                          </a>
                        ) : null}
                        {item?.youtube ? (
                          <a href={item.youtube}>
                            <YoutubeFilled
                              shape="circle"
                              style={{ color: '#6C6C6C', fontSize: '20px' }}
                            />{' '}
                            &nbsp;
                          </a>
                        ) : null}
                        {item?.twitter ? (
                          <a href={item.twitter}>
                            <TwitterSquareFilled style={{ color: '#6C6C6C', fontSize: '20px' }} />{' '}
                            &nbsp;
                          </a>
                        ) : null}
                        {/* {item?.website ? (
                      <GithubFilled style={{ color: '#6C6C6C' }} />
                      ):null} */}
                      </div>
                    </div>
                  )}
                  <div className={styles.row}>
                    <div className={styles.avatarimage}>
                      <Link
                        href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${
                          item.recruiterId
                        }`}>
                        <Avatar size={bp.xs ? 84 : 104} src={item.logo} icon={<UserOutlined />} />
                      </Link>
                    </div>
                    <div className={styles.columns1}>
                      <div className={styles.title}>
                        <Link
                          href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${
                            item.recruiterId
                          }`}>
                          <p className={styles.companyname}>{item.name} </p>
                        </Link>
                      </div>
                      <div className={bp.md ? styles.row : styles.rowMob}>
                        <div className={styles.columns2}>
                          <div className={styles.lineheight}>
                            <p className={styles.companysector}>Industry sector</p>
                            <p className={styles.companyvalue}>
                              {enumValue?.['Sector']?.[item?.sector]}
                            </p>
                          </div>
                        </div>
                        <div className={styles.columns2}>
                          <div className={styles.lineheight}>
                            <p className={styles.companysector}>Number of jobs</p>
                            <p className={styles.companyvalue}>
                              {' '}
                              {item.activeJobs} Jobs Available`
                              {/* {advertData.map((e) => e.id).indexOf(item.recruiterId) == -1
                                ? `${0} Jobs Available`
                                : `${
                                    advertData[
                                      advertData.map((e) => e.id).indexOf(item.recruiterId)
                                    ].count
                                  } Jobs Available`} */}
                            </p>
                          </div>
                        </div>
                        <div className={styles.columns2}>
                          <div className={styles.lineheight}>
                            <p className={styles.companysector}>Company size</p>
                            <p className={styles.companyvalue}>
                              {enumValue?.['Recruiter Size']?.[item.recruiterSize]}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {!bp.xs && (
                      <div className={styles.columnsIcon}>
                        <div className={styles.socialicons}>
                          {item?.website ? (
                            <a href={item?.website}>
                              <GlobalOutlined style={{ color: '#6C6C6C', fontSize: '20px' }} />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {item?.linkedin ? (
                            <a href={item.linkedin}>
                              <LinkedinFilled style={{ color: '#6C6C6C', fontSize: '20px' }} />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {item?.facebook ? (
                            <a href={item.facebook}>
                              <FacebookFilled
                                shape="circle"
                                style={{ color: '#6C6C6C', fontSize: '20px' }}
                              />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {item?.instagram ? (
                            <a href={item.instagram}>
                              <InstagramFilled
                                shape="circle"
                                style={{ color: '#6C6C6C', fontSize: '20px' }}
                              />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {item?.youtube ? (
                            <a href={item.youtube}>
                              <YoutubeFilled
                                shape="circle"
                                style={{ color: '#6C6C6C', fontSize: '20px' }}
                              />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {item?.twitter ? (
                            <a href={item.twitter}>
                              <TwitterSquareFilled style={{ color: '#6C6C6C', fontSize: '20px' }} />{' '}
                              &nbsp;
                            </a>
                          ) : null}
                          {/* {item?.website ? (
                      <GithubFilled style={{ color: '#6C6C6C' }} />
                      ):null} */}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            {total !== -1 && total !== 0 ? (
              <Pagination
                current={currentpage}
                // className={styles.pagination}
                showSizeChanger={false}
                total={total}
                responsive
                onChange={(page) => {
                  window.history.replaceState(null, 'pagination', `/recruiters?page=${page}`);
                  const params = new URLSearchParams(window.location.search);
                  if (params.get('page') == null) {
                    setCurrentPage(1);
                  } else {
                    setCurrentPage(parseInt(params.get('page') || ''));
                  }
                  page = parseInt(params.get('page') || '');
                  search({ page, size: 10 }, 'time', 'asc', searchName);
                }}
              />
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </CandidateLayout>
  );
};
